import { ILanguage } from "./common/interfaces";

export const allLanguages: ILanguage[] = [
	{
		direction: "LTR",
		name: "Abkhaz",
		code: "ab",
	},
	{
		direction: "LTR",
		name: "Afar",
		code: "aa",
	},
	{
		direction: "LTR",
		name: "Afrikaans",
		code: "af",
	},
	{
		direction: "LTR",
		name: "Akan",
		code: "ak",
	},
	{
		direction: "LTR",
		name: "Albanian",
		code: "sq",
	},
	{
		direction: "LTR",
		name: "Amharic",
		code: "am",
	},
	{
		direction: "RTL",
		name: "Arabic",
		code: "ar",
	},
	{
		direction: "LTR",
		name: "Aragonese",
		code: "an",
	},
	{
		direction: "LTR",
		name: "Armenian",
		code: "hy",
	},
	{
		direction: "LTR",
		name: "Assamese",
		code: "as",
	},
	{
		direction: "LTR",
		name: "Avaric",
		code: "av",
	},
	{
		direction: "LTR",
		name: "Avestan",
		code: "ae",
	},
	{
		direction: "LTR",
		name: "Aymara",
		code: "ay",
	},
	{
		direction: "LTR",
		name: "Azerbaijani",
		code: "az",
	},
	{
		direction: "LTR",
		name: "Bambara",
		code: "bm",
	},
	{
		direction: "LTR",
		name: "Bashkir",
		code: "ba",
	},
	{
		direction: "LTR",
		name: "Basque",
		code: "eu",
	},
	{
		direction: "LTR",
		name: "Belarusian",
		code: "be",
	},
	{
		direction: "LTR",
		name: "Bengali",
		code: "bn",
	},
	{
		direction: "LTR",
		name: "Berber",
		code: "ber",
	},
	{
		direction: "LTR",
		name: "Bihari",
		code: "bh",
	},
	{
		direction: "LTR",
		name: "Bislama",
		code: "bi",
	},
	{
		direction: "LTR",
		name: "Bosnian",
		code: "bs",
	},
	{
		direction: "LTR",
		name: "Breton",
		code: "br",
	},
	{
		direction: "LTR",
		name: "Bulgarian",
		code: "bg",
	},
	{
		direction: "LTR",
		name: "Burmese",
		code: "my",
	},
	{
		direction: "LTR",
		name: "Catalan",
		code: "ca",
	},
	{
		direction: "LTR",
		name: "Chamorro",
		code: "ch",
	},
	{
		direction: "LTR",
		name: "Chechen",
		code: "ce",
	},
	{
		direction: "LTR",
		name: "Chichewa",
		code: "ny",
	},
	{
		direction: "LTR",
		name: "Chinese",
		code: "zh",
	},
	{
		direction: "LTR",
		name: "Chuvash",
		code: "cv",
	},
	{
		direction: "LTR",
		name: "Cornish",
		code: "kw",
	},
	{
		direction: "LTR",
		name: "Corsican",
		code: "co",
	},
	{
		direction: "LTR",
		name: "Cree",
		code: "cr",
	},
	{
		direction: "LTR",
		name: "Croatian",
		code: "hr",
	},
	{
		direction: "LTR",
		name: "Czech",
		code: "cs",
	},
	{
		direction: "LTR",
		name: "Danish",
		code: "da",
	},
	{
		direction: "RTL",
		name: "Divehi",
		code: "dv",
	},
	{
		direction: "LTR",
		name: "Dutch",
		code: "nl",
	},
	{
		direction: "LTR",
		name: "Dzongkha",
		code: "dz",
	},
	{
		direction: "LTR",
		name: "English",
		code: "en",
	},
	{
		direction: "LTR",
		name: "Esperanto",
		code: "eo",
	},
	{
		direction: "LTR",
		name: "Estonian",
		code: "et",
	},
	{
		direction: "LTR",
		name: "Ewe",
		code: "ee",
	},
	{
		direction: "LTR",
		name: "Faroese",
		code: "fo",
	},
	{
		direction: "LTR",
		name: "Fijian",
		code: "fj",
	},
	{
		direction: "LTR",
		name: "Finnish",
		code: "fi",
	},
	{
		direction: "LTR",
		name: "French",
		code: "fr",
	},
	{
		direction: "LTR",
		name: "Fula",
		code: "ff",
	},
	{
		direction: "LTR",
		name: "Galician",
		code: "gl",
	},
	{
		direction: "LTR",
		name: "Georgian",
		code: "ka",
	},
	{
		direction: "LTR",
		name: "German",
		code: "de",
	},
	{
		direction: "LTR",
		name: "Greek",
		code: "el",
	},
	{
		direction: "LTR",
		name: "Guaraní",
		code: "gn",
	},
	{
		direction: "LTR",
		name: "Gujarati",
		code: "gu",
	},
	{
		direction: "LTR",
		name: "Haitian",
		code: "ht",
	},
	{
		direction: "LTR",
		name: "Hausa",
		code: "ha",
	},
	{
		direction: "RTL",
		name: "Hebrew",
		code: "he",
	},
	{
		direction: "LTR",
		name: "Herero",
		code: "hz",
	},
	{
		direction: "LTR",
		name: "Hindi",
		code: "hi",
	},
	{
		direction: "LTR",
		name: "Hiri Motu",
		code: "ho",
	},
	{
		direction: "LTR",
		name: "Hungarian",
		code: "hu",
	},
	{
		direction: "LTR",
		name: "Interlingua",
		code: "ia",
	},
	{
		direction: "LTR",
		name: "Indonesian",
		code: "id",
	},
	{
		direction: "LTR",
		name: "Interlingue",
		code: "ie",
	},
	{
		direction: "LTR",
		name: "Irish",
		code: "ga",
	},
	{
		direction: "LTR",
		name: "Igbo",
		code: "ig",
	},
	{
		direction: "LTR",
		name: "Inupiaq",
		code: "ik",
	},
	{
		direction: "LTR",
		name: "Ido",
		code: "io",
	},
	{
		direction: "LTR",
		name: "Icelandic",
		code: "is",
	},
	{
		direction: "LTR",
		name: "Italian",
		code: "it",
	},
	{
		direction: "LTR",
		name: "Inuktitut",
		code: "iu",
	},
	{
		direction: "LTR",
		name: "Japanese",
		code: "ja",
	},
	{
		direction: "LTR",
		name: "Javanese",
		code: "jv",
	},
	{
		direction: "LTR",
		name: "Kalaallisut",
		code: "kl",
	},
	{
		direction: "LTR",
		name: "Kannada",
		code: "kn",
	},
	{
		direction: "LTR",
		name: "Kanuri",
		code: "kr",
	},
	{
		direction: "LTR",
		name: "Kashmiri",
		code: "ks",
	},
	{
		direction: "LTR",
		name: "Kazakh",
		code: "kk",
	},
	{
		direction: "LTR",
		name: "Khmer",
		code: "km",
	},
	{
		direction: "LTR",
		name: "Kikuyu",
		code: "ki",
	},
	{
		direction: "LTR",
		name: "Kinyarwanda",
		code: "rw",
	},
	{
		direction: "LTR",
		name: "Kyrgyz",
		code: "ky",
	},
	{
		direction: "LTR",
		name: "Komi",
		code: "kv",
	},
	{
		direction: "LTR",
		name: "Kongo",
		code: "kg",
	},
	{
		direction: "LTR",
		name: "Korean",
		code: "ko",
	},
	{
		direction: "RTL",
		name: "Kurdish",
		code: "ku",
	},
	{
		direction: "LTR",
		name: "Kwanyama",
		code: "kj",
	},
	{
		direction: "LTR",
		name: "Latin",
		code: "la",
	},
	{
		direction: "LTR",
		name: "Luxembourgish",
		code: "lb",
	},
	{
		direction: "LTR",
		name: "Ganda",
		code: "lg",
	},
	{
		direction: "LTR",
		name: "Limburgish",
		code: "li",
	},
	{
		direction: "LTR",
		name: "Lingala",
		code: "ln",
	},
	{
		direction: "LTR",
		name: "Lao",
		code: "lo",
	},
	{
		direction: "LTR",
		name: "Lithuanian",
		code: "lt",
	},
	{
		direction: "LTR",
		name: "Luba-Katanga",
		code: "lu",
	},
	{
		direction: "LTR",
		name: "Latvian",
		code: "lv",
	},
	{
		direction: "LTR",
		name: "Manx",
		code: "gv",
	},
	{
		direction: "LTR",
		name: "Macedonian",
		code: "mk",
	},
	{
		direction: "LTR",
		name: "Malagasy",
		code: "mg",
	},
	{
		direction: "LTR",
		name: "Malay",
		code: "ms",
	},
	{
		direction: "LTR",
		name: "Malayalam",
		code: "ml",
	},
	{
		direction: "LTR",
		name: "Maltese",
		code: "mt",
	},
	{
		direction: "LTR",
		name: "Māori",
		code: "mi",
	},
	{
		direction: "LTR",
		name: "Marathi (Marāṭhī)",
		code: "mr",
	},
	{
		direction: "LTR",
		name: "Marshallese",
		code: "mh",
	},
	{
		direction: "LTR",
		name: "Mongolian",
		code: "mn",
	},
	{
		direction: "LTR",
		name: "Nauru",
		code: "na",
	},
	{
		direction: "LTR",
		name: "Navajo",
		code: "nv",
	},
	{
		direction: "LTR",
		name: "Norwegian Bokmål",
		code: "nb",
	},
	{
		direction: "LTR",
		name: "Northern Ndebele",
		code: "nd",
	},
	{
		direction: "LTR",
		name: "Northern Sotho",
		code: "nso",
	},
	{
		direction: "LTR",
		name: "Nepali",
		code: "ne",
	},
	{
		direction: "LTR",
		name: "Ndonga",
		code: "ng",
	},
	{
		direction: "LTR",
		name: "Norwegian Nynorsk",
		code: "nn",
	},
	{
		direction: "LTR",
		name: "Norwegian",
		code: "no",
	},
	{
		direction: "LTR",
		name: "Nuosu",
		code: "ii",
	},
	{
		direction: "LTR",
		name: "Southern Ndebele",
		code: "nr",
	},
	{
		direction: "LTR",
		name: "Occitan",
		code: "oc",
	},
	{
		direction: "LTR",
		name: "Ojibwe",
		code: "oj",
	},
	{
		direction: "LTR",
		name: "Old Church Slavonic",
		code: "cu",
	},
	{
		direction: "LTR",
		name: "Oromo",
		code: "om",
	},
	{
		direction: "LTR",
		name: "Oriya",
		code: "or",
	},
	{
		direction: "LTR",
		name: "Ossetian",
		code: "os",
	},
	{
		direction: "LTR",
		name: "Panjabi",
		code: "pa",
	},
	{
		direction: "LTR",
		name: "Pāli",
		code: "pi",
	},
	{
		direction: "RTL",
		name: "Persian",
		code: "fa",
	},
	{
		direction: "LTR",
		name: "Polish",
		code: "pl",
	},
	{
		direction: "RTL",
		name: "Pashto",
		code: "ps",
	},
	{
		direction: "LTR",
		name: "Portuguese",
		code: "pt",
	},
	{
		direction: "LTR",
		name: "Quechua",
		code: "qu",
	},
	{
		direction: "LTR",
		name: "Romansh",
		code: "rm",
	},
	{
		direction: "LTR",
		name: "Kirundi",
		code: "rn",
	},
	{
		direction: "LTR",
		name: "Romanian",
		code: "ro",
	},
	{
		direction: "LTR",
		name: "Russian",
		code: "ru",
	},
	{
		direction: "LTR",
		name: "Sanskrit (Saṁskṛta)",
		code: "sa",
	},
	{
		direction: "LTR",
		name: "Sardinian",
		code: "sc",
	},
	{
		direction: "RTL",
		name: "Sindhi",
		code: "sd",
	},
	{
		direction: "LTR",
		name: "Northern Sami",
		code: "se",
	},
	{
		direction: "LTR",
		name: "Samoan",
		code: "sm",
	},
	{
		direction: "LTR",
		name: "Sango",
		code: "sg",
	},
	{
		direction: "LTR",
		name: "Serbian",
		code: "sr",
	},
	{
		direction: "LTR",
		name: "Scottish Gaelic",
		code: "gd",
	},
	{
		direction: "LTR",
		name: "Shona",
		code: "sn",
	},
	{
		direction: "LTR",
		name: "Sinhala",
		code: "si",
	},
	{
		direction: "LTR",
		name: "Slovak",
		code: "sk",
	},
	{
		direction: "LTR",
		name: "Slovene",
		code: "sl",
	},
	{
		direction: "LTR",
		name: "Somali",
		code: "so",
	},
	{
		direction: "LTR",
		name: "Southern Sotho",
		code: "st",
	},
	{
		direction: "LTR",
		name: "Spanish",
		code: "es",
	},
	{
		direction: "LTR",
		name: "Sundanese",
		code: "su",
	},
	{
		direction: "LTR",
		name: "Swahili",
		code: "sw",
	},
	{
		direction: "LTR",
		name: "Swati",
		code: "ss",
	},
	{
		direction: "LTR",
		name: "Swedish",
		code: "sv",
	},
	{
		direction: "LTR",
		name: "Tamil",
		code: "ta",
	},
	{
		direction: "LTR",
		name: "Telugu",
		code: "te",
	},
	{
		direction: "LTR",
		name: "Tajik",
		code: "tg",
	},
	{
		direction: "LTR",
		name: "Thai",
		code: "th",
	},
	{
		direction: "LTR",
		name: "Tigrinya",
		code: "ti",
	},
	{
		direction: "LTR",
		name: "Tibetan Standard",
		code: "bo",
	},
	{
		direction: "LTR",
		name: "Turkmen",
		code: "tk",
	},
	{
		direction: "LTR",
		name: "Tagalog",
		code: "tl",
	},
	{
		direction: "LTR",
		name: "Filipino",
		code: "fil",
	},
	{
		direction: "LTR",
		name: "Tswana",
		code: "tn",
	},
	{
		direction: "LTR",
		name: "Tonga (Tonga Islands)",
		code: "to",
	},
	{
		direction: "LTR",
		name: "Turkish",
		code: "tr",
	},
	{
		direction: "LTR",
		name: "Tsonga",
		code: "ts",
	},
	{
		direction: "LTR",
		name: "Tatar",
		code: "tt",
	},
	{
		direction: "LTR",
		name: "Twi",
		code: "tw",
	},
	{
		direction: "LTR",
		name: "Tahitian",
		code: "ty",
	},
	{
		direction: "RTL",
		name: "Uyghur",
		code: "ug",
	},
	{
		direction: "LTR",
		name: "Ukrainian",
		code: "uk",
	},
	{
		direction: "RTL",
		name: "Urdu",
		code: "ur",
	},
	{
		direction: "LTR",
		name: "Uzbek",
		code: "uz",
	},
	{
		direction: "LTR",
		name: "Venda",
		code: "ve",
	},
	{
		direction: "LTR",
		name: "Vietnamese",
		code: "vi",
	},
	{
		direction: "LTR",
		name: "Volapük",
		code: "vo",
	},
	{
		direction: "LTR",
		name: "Walloon",
		code: "wa",
	},
	{
		direction: "LTR",
		name: "Welsh",
		code: "cy",
	},
	{
		direction: "LTR",
		name: "Wolof",
		code: "wo",
	},
	{
		direction: "LTR",
		name: "Western Frisian",
		code: "fy",
	},
	{
		direction: "LTR",
		name: "Xhosa",
		code: "xh",
	},
	{
		direction: "RTL",
		name: "Yiddish",
		code: "yi",
	},
	{
		direction: "LTR",
		name: "Yoruba",
		code: "yo",
	},
	{
		direction: "LTR",
		name: "Zhuang",
		code: "za",
	},
	{
		direction: "LTR",
		name: "Zulu",
		code: "zu",
	},
];
